<div class="p-[50px]">
  <mat-card appearance="filled" class="flex flex-col">
    <mat-card-header class="flex items-center justify-between">
      <h3 class="font-medium tracking-tight text-md" matCardTitle>Nouveau projet</h3>
      <button mat-raised-button type="button" color="primary" (click)="valider()">Valider</button>
    </mat-card-header>
    <mat-card-content class="flex flex-auto flex-col overflow-hidden p-4 gap-2">
      <form class="example-form">
        <div class="w-full flex justify-between gap-4">
          <mat-form-field appearance="outline" class="w-full text-[14px]">
            <mat-label>Libellé</mat-label>
            <input matInput [(ngModel)]="nouveauProjet.libelle" name="nouveauProjet.libelle">
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full text-[14px]">
            <mat-label>Zone</mat-label>
            <input type="text" matInput [matAutocomplete]="auto"
                   [(ngModel)]="nouveauProjet.zone"
                   (keyup)="filterZone()" name="nouveauProjet.zone">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let zone of zonesSearch" [value]="zone">{{ zone }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full text-[14px]">
            <mat-label>Utilisateur</mat-label>
            <mat-select [(ngModel)]="nouveauProjet.utilisateur" name="nouveauProjet.utilisateur"
                        >
              <mat-option *ngFor="let utilisateur of utilisateurs" [value]="utilisateur.id">
                {{ utilisateur.prenomNom }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="w-full max-w-[260px] flex flex-col gap-2">
            <label class="text-sm font-medium text-gray-700">Fichier KML</label>
            <input
              type="file"
              accept=".kml"
              name="fichierKml"
              class="block w-full rounded-md bg-white py-2 text-sm text-gray-700 file:mr-3 file:rounded-md file:border-0 file:bg-slate-100 file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-gray-700 hover:file:bg-slate-200"
              (change)="onKmlFileChange($event)"
            >
          </div>
          <div class="w-full max-w-[260px] flex flex-col gap-2">
            <label class="text-sm font-medium text-gray-700">Fichier Orange</label>
            <input
              type="file"
              accept=".kml"
              name="fichierOrange"
              class="block w-full rounded-md bg-white py-2 text-sm text-gray-700 file:mr-3 file:rounded-md file:border-0 file:bg-slate-100 file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-gray-700 hover:file:bg-slate-200"
              (change)="onOrangeFileChange($event)"
            >
          </div>
          <div class="w-full max-w-[260px] flex flex-col gap-2">
            <label class="text-sm font-medium text-gray-700">Fichiers KML supplémentaires</label>
            <input
              type="file"
              accept=".kml"
              name="fichiersKmlSupplementaires"
              multiple
              class="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-700 file:mr-3 file:rounded-md file:border-0 file:bg-slate-100 file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-gray-700 hover:file:bg-slate-200"
              (change)="onKmlSupplementairesChange($event)"
            >
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <br><br>

  <mat-form-field>
    <mat-label>Recherche</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Recherche">
  </mat-form-field>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="identifiant">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Identifiant</th>
        <td mat-cell *matCellDef="let row"> {{ row.id }}</td>
      </ng-container>

      <ng-container matColumnDef="libelle">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Projet</th>
        <td mat-cell *matCellDef="let row"> {{ row.libelle }}</td>
      </ng-container>

      <ng-container matColumnDef="nbPoteaux">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre de reprises</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.nbPoteaux">
            <button mat-icon-button color="primary" (click)="nombreReprises(row.nbPoteaux, row.kml)"
                    class="text-cyan-500">
                  <mat-icon class="icon-size-4 text-[16px] leading-4">info</mat-icon>
                </button>
            </span>
          <span *ngIf="!row.nbPoteaux">Aucune reprise</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="zone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Zone</th>
        <td mat-cell *matCellDef="let row"> {{ row.zone }}</td>
      </ng-container>

      <ng-container matColumnDef="utilisateur">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Utilisateur</th>
        <td mat-cell *matCellDef="let row"> {{ getUserDisplayName(row.utilisateur) }}</td>
      </ng-container>

      <ng-container matColumnDef="dateCloture">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de cloture</th>
        <td mat-cell *matCellDef="let row"><span
          *ngIf="row.dateCloture">{{ row.dateCloture.seconds * 1000 | date: 'dd/MM/yyyy hh:mm' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Etat</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="!row.actif" class="text-red-600">FERMÉ</span>
          <span *ngIf="row.actif" class="text-lime-600">OUVERT</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions</th>
        <td mat-cell *matCellDef="let row">
          <div class="flex items-center gap-1">
            <button mat-icon-button color="primary" (click)="genererKmlManquants(row)"
                    matTooltip="Générer un kml avec les poteaux manquants">
              <mat-icon color="warn" class="icon-size-4 text-[16px] leading-4">fmd_bad</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="comparaisonImage(row)"
                    matTooltip="Comparaison des images" class="text-cyan-500">
              <mat-icon class="icon-size-4 text-[16px] leading-4">insert_photo</mat-icon>
            </button>
            <span *ngIf="row.actif">
              <button mat-icon-button class="text-red-600" matTooltip="Fermer" (click)="changerEtat(row, false)">
                <mat-icon class="icon-size-4 text-[16px] leading-4">lock</mat-icon>
              </button>
            </span>
            <span *ngIf="!row.actif">
              <button mat-icon-button class="text-lime-600" matTooltip="Ouvrir" (click)="changerEtat(row, true)">
                <mat-icon class="icon-size-4 text-[16px] leading-4">lock_open</mat-icon>
              </button>
            </span>
            <button mat-icon-button color="primary" (click)="changerTechnicien(row)"
                    class="text-orange-600" matTooltip="Changer de technicien">
              <mat-icon class="icon-size-4 text-[16px] leading-4">person</mat-icon>
            </button>
            <button [disabled]="row.actif" mat-icon-button color="primary"
                    matTooltip="Générer les kmls"
                    (click)="genererKml(row.id, row.libelle)">
              <mat-icon class="icon-size-4 text-[16px] leading-4">get_app</mat-icon>
            </button>
            <button [disabled]="row.actif" mat-icon-button color="accent" (click)="archiver(row)"
                    matTooltip="Archiver">
              <mat-icon class="icon-size-4 text-[16px] leading-4">inbox</mat-icon>
            </button>
            <button [disabled]="row.actif" mat-icon-button color="warn" (click)="supprimer(row.id)"
                    matTooltip="Supprimer">
              <mat-icon class="icon-size-4 text-[16px] leading-4">delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;">
      </tr>
    </table>

    <mat-paginator pageSize="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
</div>
